import PropTypes from 'prop-types';
import React from 'react';
import FormsSelect from './FormsSelect';

// Account filter for the Forms list: "All accounts (N)" then every account
// that has forms in the current view, "<name> (count)". onChange gets an
// account id, or null for all. A custom dropdown (FormsSelect): type to
// find an account, arrows and Enter to pick.
const ALL = 'all';

const AccountFilter = ({ accounts, value, total, onChange, width }) => {
  const options = [
    { label: `All accounts (${total})`, value: ALL },
    ...accounts.map((a) => ({
      label: `${a.name} (${a.count})`,
      value: String(a.account_id),
    })),
  ];
  // An account in the URL with no forms in this view still shows as picked.
  if (value && !accounts.some((a) => a.account_id === value)) {
    options.push({ label: 'This account (0)', value: String(value) });
  }

  return (
    <div style={{ width, minWidth: 0 }}>
      <FormsSelect
        id="forms-account-filter"
        ariaLabel="Filter by account"
        icon="flag"
        dataTour="forms-filter"
        value={value ? String(value) : ALL}
        options={options}
        onChange={(next) => onChange(next === ALL ? null : Number(next))}
      />
    </div>
  );
};

AccountFilter.propTypes = {
  accounts: PropTypes.arrayOf(
    PropTypes.shape({
      account_id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
    })
  ).isRequired,
  value: PropTypes.number,
  total: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  width: PropTypes.string,
};

AccountFilter.defaultProps = {
  value: null,
  total: 0,
  width: '260px',
};

export default AccountFilter;
